import Image from "next/image";
import { useMantineTheme } from "@mantine/core";
import { addBasePathToStrapiMedia, formatStrapiEntity } from "@/utils/strapi";
import { StrapiEntity, StrapiImage } from "@/utils/strapi";
import { Section } from "@/components/common/section/Section";
import HydratedMediaQuery from "@/utils/hydratedMediaQuery";
import { getBreakpoint } from "@/utils/mantine";
import styles from "./Banner.module.scss";

export type BannerProps = {
  desktopBanner: StrapiEntity<StrapiImage> | null;
  mobileBanner: StrapiEntity<StrapiImage> | null;
};

export const Banner = ({ desktopBanner, mobileBanner }: BannerProps) => {
  const theme = useMantineTheme();
  const isTabletOrDesktop = HydratedMediaQuery(
    getBreakpoint(theme.breakpoints.md)
  );

  let strapiImage: StrapiImage | null = null;

  if (isTabletOrDesktop) {
    strapiImage =
      desktopBanner !== null ? formatStrapiEntity(desktopBanner) : null;
  } else {
    strapiImage =
      mobileBanner !== null ? formatStrapiEntity(mobileBanner) : null;
  }

  return (
    <Section>
      {strapiImage !== null && (
        <div className={`${styles.imageWrapper}`}>
          <Image
            src={addBasePathToStrapiMedia(strapiImage)}
            objectFit="contain"
            objectPosition="center"
            alt={strapiImage.alternativeText}
            layout="fill"
          />
        </div>
      )}
    </Section>
  );
};
